
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TemplateItemProps } from ".";
import { loading, update } from "store/template";
import { AppMessage } from "components";

interface ApiTemplateUpdateInputProps extends TemplateItemProps {
}

type ApiTemplateUpdateOutputProps = OutputBaseProps<{ item: TemplateItemProps; }, ApiTemplateUpdateInputProps>

export const apiTemplateUpdate = async (data: ApiTemplateUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiTemplateUpdateOutputProps>("/api/template/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};